import { Component, ContentChildren, OnDestroy, OnInit, QueryList } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccordionItemComponent } from 'src/app/shared/accordion/accordion-item/accordion-item.component';
import { AccordionService } from 'src/app/shared/accordion/accordion.service';
import { AccordionState } from 'src/app/shared/accordion/accordion.state';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion-main.component.html',
  styleUrls: ['./accordion-main.component.scss']
})
export class AccordionMainComponent implements OnInit, OnDestroy {
  @ContentChildren(AccordionItemComponent) items !: QueryList<AccordionItemComponent>;
  active: AccordionState;
  private subscription$: Subscription;

  constructor(
    private accordionService: AccordionService
  ) { }

  ngOnInit(): void {
    this.subscription$ = this.accordionService.accordion$.subscribe((data) => {
      this.active = data;
      this.setValue();
    });
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  setValue() {
    if (this.items) {
      this.items.toArray()
        .filter(accordion => accordion.id !== this.active.id)
        .map(item => {
          item.hideContent();
        });
    }
  }
}
